import * as React from "react"
import { StoreProvider } from "./src/context/store-context"
import "@fontsource/barlow/latin.css"
import "@fontsource/barlow-condensed/latin.css"
import "./src/css/styles.css"

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)